import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import BreadcrumbPath from '../common/BreadcrumbPath';

export const withDemographic = BreadcrumbPathComponent => props => {
  const DEMOGRAPHIC_QUERY = gql`
    query getDemographicPathQuery($ids: [ID!]) {
      Demographic(filter: { id_in: $ids }) {
        id
        name
      }
    }
  `;
  const demographicQueryResult = useQuery(DEMOGRAPHIC_QUERY, { variables: { ids: props.initiallySelectedIds } });
  const { loading, error, data } = demographicQueryResult;

  return props.path ? (
    <BreadcrumbPathComponent {...props} />
  ) : !loading && !error && data && data.Demographic ? (
    <BreadcrumbPathComponent {...props} path={data.Demographic} />
  ) : null;
};

export default withDemographic(BreadcrumbPath);
